module.exports = __webpack_public_path__ + "static/img/bg-2.3a50c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-2.png
// module id = z0hZ
// module chunks = 4